export default __webpack_public_path__ + "static/media/Zone-6-Master-Plan.214db9da.png";